import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const scifiDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 61: 宇宙探査ロケット
  61: (ctx, cx, cy, mode) => {
    const drawRocket = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy - 210);
      ctx.bezierCurveTo(cx + 55, cy - 120, cx + 55, cy + 100, cx + 55, cy + 130);
      ctx.lineTo(cx - 55, cy + 130);
      ctx.bezierCurveTo(cx - 55, cy + 100, cx - 55, cy - 120, cx, cy - 210);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.moveTo(cx - 55, cy + 60); ctx.lineTo(cx - 105, cy + 160); ctx.lineTo(cx - 55, cy + 140); ctx.fill();
      ctx.beginPath(); ctx.moveTo(cx + 55, cy + 60); ctx.lineTo(cx + 105, cy + 160); ctx.lineTo(cx + 55, cy + 140); ctx.fill();
      drawRocket(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.moveTo(cx - 55, cy + 60); ctx.lineTo(cx - 105, cy + 160); ctx.lineTo(cx - 55, cy + 140); ctx.closePath(); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx + 55, cy + 60); ctx.lineTo(cx + 105, cy + 160); ctx.lineTo(cx + 55, cy + 140); ctx.closePath(); ctx.stroke();
        drawRocket(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 40, 24, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 100, 210, 100, PALETTE.crimson, 'lacquer');
      ctx.beginPath(); ctx.moveTo(cx - 55, cy + 60); ctx.lineTo(cx - 105, cy + 160); ctx.lineTo(cx - 55, cy + 140); ctx.fill();
      ctx.beginPath(); ctx.moveTo(cx + 55, cy + 60); ctx.lineTo(cx + 105, cy + 160); ctx.lineTo(cx + 55, cy + 140); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 40, 110, 340, PALETTE.white, 'metallic');
      drawRocket(); ctx.fill();
      ctx.fillStyle = PALETTE.crimson;
      ctx.beginPath(); ctx.moveTo(cx, cy - 210); ctx.bezierCurveTo(cx + 40, cy - 140, cx - 40, cy - 140, cx, cy - 210); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx, cy - 40, 24, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 15, cy - 80, 20, 50, 0.65);
    }
  },

  // STAGE 62: スペースシャトル
  62: (ctx, cx, cy, mode) => {
    const drawShuttle = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy - 190);
      ctx.bezierCurveTo(cx + 40, cy - 90, cx + 45, cy + 30, cx + 130, cy + 140);
      ctx.lineTo(cx + 45, cy + 140);
      ctx.lineTo(cx + 45, cy + 170);
      ctx.lineTo(cx - 45, cy + 170);
      ctx.lineTo(cx - 45, cy + 140);
      ctx.lineTo(cx - 130, cy + 140);
      ctx.bezierCurveTo(cx - 45, cy + 30, cx - 40, cy - 90, cx, cy - 190);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawShuttle(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawShuttle(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 190, 20, 0, Math.PI); ctx.stroke();
        ctx.strokeRect(cx - 20, cy - 110, 40, 16);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 260, 360, PALETTE.white, 'metallic');
      drawShuttle(); ctx.fill();
      ctx.fillStyle = PALETTE.dark;
      ctx.beginPath(); ctx.arc(cx, cy - 190, 20, 0, Math.PI); ctx.fill();
      ctx.fillRect(cx - 20, cy - 110, 40, 16);
      ctx.fillStyle = PALETTE.cyan;
      ctx.fillRect(cx - 15, cy - 108, 30, 12);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 18, cy - 40, 25, 60, 0.55);
    }
  },

  // STAGE 63: 宇宙ステーション
  63: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.fillRect(cx - 160, cy - 80, 80, 160);
      ctx.fillRect(cx + 80, cy - 80, 80, 160);
      ctx.fillStyle = '#FAF8F5';
      ctx.fillRect(cx - 80, cy - 15, 160, 30);
      ctx.beginPath(); ctx.ellipse(cx, cy, 35, 60, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.strokeRect(cx - 160, cy - 80, 80, 160);
        ctx.strokeRect(cx + 80, cy - 80, 80, 160);
        ctx.strokeRect(cx - 80, cy - 15, 160, 30);
        ctx.beginPath(); ctx.ellipse(cx, cy, 35, 60, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 120, cy, 80, 160, PALETTE.deepBlue, 'metallic');
      ctx.fillRect(cx - 160, cy - 80, 80, 160);
      ctx.fillRect(cx + 80, cy - 80, 80, 160);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 70, 120, PALETTE.silver, 'metallic');
      ctx.beginPath(); ctx.ellipse(cx, cy, 35, 60, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillRect(cx - 80, cy - 15, 160, 30);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 10, cy - 20, 15, 25, 0.6);
    }
  },

  // STAGE 64: 真鍮の天球儀 / 太陽系儀
  64: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy, 110, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx, cy, 90, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx, cy, 35, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.fillRect(cx - 8, cy + 110, 16, 70);
      ctx.beginPath(); ctx.ellipse(cx, cy + 180, 60, 18, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx, cy, 110, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 90, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 35, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy, 110, 45, 0.4, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 8, cy + 110, 16, 70);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 220, 220, PALETTE.brass, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy, 110, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.purple;
      ctx.beginPath(); ctx.arc(cx, cy, 90, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 70, 70, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy, 35, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx + 60, cy - 20, 12, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 10, cy - 10, 15, 15, 0.65);
    }
  },

  // STAGE 65: UFOフライングソーサー
  65: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy - 10, 65, Math.PI, 0); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.ellipse(cx, cy + 20, 140, 50, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx, cy - 10, 65, Math.PI, 0); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy + 20, 140, 50, 0, 0, Math.PI * 2); ctx.stroke();
        for (let i = -2; i <= 2; i++) {
          ctx.beginPath(); ctx.arc(cx + i * 45, cy + 30, 10, 0, Math.PI * 2); ctx.stroke();
        }
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 10, 130, 65, PALETTE.purple, 'glass');
      ctx.beginPath(); ctx.arc(cx, cy - 10, 65, Math.PI, 0); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 20, 280, 100, PALETTE.silver, 'metallic');
      ctx.beginPath(); ctx.ellipse(cx, cy + 20, 140, 50, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.emerald;
      for (let i = -2; i <= 2; i++) {
        ctx.beginPath(); ctx.arc(cx + i * 45, cy + 30, 10, 0, Math.PI * 2); ctx.fill();
      }
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 25, 30, 15, 0.6);
    }
  },

  // STAGE 66: 火星探査ローバー
  66: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.roundRect(cx - 90, cy - 40, 180, 80, 12); ctx.fill();
      ctx.fillRect(cx + 40, cy - 140, 14, 100);
      ctx.fillRect(cx + 25, cy - 160, 45, 25);
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx - 85, cy + 75, 25, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy + 75, 25, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 85, cy + 75, 25, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.roundRect(cx - 90, cy - 40, 180, 80, 12); ctx.stroke();
        ctx.strokeRect(cx + 40, cy - 140, 14, 100);
        ctx.strokeRect(cx + 25, cy - 160, 45, 25);
        ctx.beginPath(); ctx.arc(cx - 85, cy + 75, 25, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy + 75, 25, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 85, cy + 75, 25, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 180, 80, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.roundRect(cx - 90, cy - 40, 180, 80, 12); ctx.fill();
      ctx.fillStyle = PALETTE.charcoal;
      ctx.fillRect(cx + 40, cy - 140, 14, 100);
      ctx.fillRect(cx + 25, cy - 160, 45, 25);
      ctx.beginPath(); ctx.arc(cx - 85, cy + 75, 25, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy + 75, 25, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 85, cy + 75, 25, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx + 47, cy - 148, 8, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 20, 30, 14, 0.55);
    }
  },

  // STAGE 67: プラズマブラスター
  67: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath();
      ctx.moveTo(cx - 60, cy + 20); ctx.lineTo(cx - 90, cy + 150); ctx.lineTo(cx - 40, cy + 150); ctx.lineTo(cx - 20, cy + 20); ctx.closePath(); ctx.fill();
      ctx.fillRect(cx - 60, cy - 60, 190, 80);
      ctx.fillStyle = '#FAF8F5'; ctx.fillRect(cx - 10, cy - 45, 90, 50);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath();
        ctx.moveTo(cx - 60, cy + 20); ctx.lineTo(cx - 90, cy + 150); ctx.lineTo(cx - 40, cy + 150); ctx.lineTo(cx - 20, cy + 20); ctx.closePath(); ctx.stroke();
        ctx.strokeRect(cx - 60, cy - 60, 190, 80);
        ctx.strokeRect(cx - 10, cy - 45, 90, 50);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 190, 150, PALETTE.dark, 'metallic');
      ctx.beginPath();
      ctx.moveTo(cx - 60, cy + 20); ctx.lineTo(cx - 90, cy + 150); ctx.lineTo(cx - 40, cy + 150); ctx.lineTo(cx - 20, cy + 20); ctx.closePath(); ctx.fill();
      ctx.fillRect(cx - 60, cy - 60, 190, 80);
      ctx.fillStyle = PALETTE.cyan;
      ctx.fillRect(cx - 10, cy - 45, 90, 50);
      ctx.fillStyle = PALETTE.purple;
      ctx.fillRect(cx + 100, cy - 70, 30, 100);
      ShadingPipeline.renderSpecularGlint(ctx, cx + 30, cy - 25, 35, 14, 0.65);
    }
  },

  // STAGE 68: サイバーヘルメット
  68: (ctx, cx, cy, mode) => {
    const drawHelmet = () => {
      ctx.beginPath();
      ctx.arc(cx, cy - 30, 110, Math.PI, 0);
      ctx.lineTo(cx + 100, cy + 90);
      ctx.lineTo(cx + 40, cy + 140);
      ctx.lineTo(cx - 40, cy + 140);
      ctx.lineTo(cx - 100, cy + 90);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawHelmet(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.roundRect(cx - 80, cy - 20, 160, 60, 14); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawHelmet(); ctx.stroke();
        ctx.beginPath(); ctx.roundRect(cx - 80, cy - 20, 160, 60, 14); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 220, 250, PALETTE.purple, 'lacquer');
      drawHelmet(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 10, 160, 60, PALETTE.cyan, 'glass');
      ctx.beginPath(); ctx.roundRect(cx - 80, cy - 20, 160, 60, 14); ctx.fill();
      ctx.fillStyle = PALETTE.yellow;
      ctx.fillRect(cx - 20, cy + 85, 40, 20);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 80, 45, 18, 0.6);
    }
  },

  // STAGE 69: アンドロイド
  69: (ctx, cx, cy, mode) => {
    const drawHead = () => {
      ctx.beginPath(); ctx.ellipse(cx, cy - 40, 80, 105, 0, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.fillRect(cx - 30, cy + 60, 60, 100);
      drawHead(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.strokeRect(cx - 30, cy + 60, 60, 100);
        drawHead(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 25, cy - 40, 12, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 25, cy - 40, 12, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 60, 60, 100, PALETTE.silver, 'metallic');
      ctx.fillRect(cx - 30, cy + 60, 60, 100);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 40, 160, 210, PALETTE.white, 'ceramic');
      drawHead(); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx - 25, cy - 40, 12, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 25, cy - 40, 12, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.fillRect(cx + 40, cy - 80, 8, 80);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 75, 30, 30, 0.55);
    }
  },

  // STAGE 70: タイムマシン
  70: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy - 20, 115, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx, cy - 20, 85, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.fillRect(cx - 10, cy + 95, 20, 60);
      ctx.beginPath(); ctx.ellipse(cx, cy + 160, 70, 20, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx, cy - 20, 115, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 20, 85, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy - 20, 85, 35, 0.5, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 10, cy + 95, 20, 60);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 20, 230, 230, PALETTE.brass, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy - 20, 115, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.purple;
      ctx.beginPath(); ctx.arc(cx, cy - 20, 85, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx, cy - 20, 30, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 50, 45, 18, 0.65);
    }
  }
};
